import api from './api'

export default {
  list() {
    return api.get('/rejection-reasons')
  },
}
